export {composeRenderProps} from '../src/utils';
